// app/frontend-react/src/lib/config.js
//
// Port 1:1 de src/js/config.js (app/frontend). Misma variable de entorno
// Vite, mismo fallback `?.` para cuando este modulo se cargue fuera de
// Vite (pruebas con un server plano). MISMA clave de localStorage que
// theme-boot.js espera (window.__THEME_KEY__) -- ver src/theme/theme.js.
export const API_BASE_URL = import.meta.env?.VITE_API_BASE_URL ?? '';

export const REMEMBER_TOKEN_KEY = 'solicitudesbi_remember_token';

// Llave APARTE para el portal de Proveedores (doc 29, punto 1 de Manuel):
// ProveedorApp.jsx maneja su sesion de forma local, nunca via
// sessionStore.js -- si compartiera la misma llave, un navegador usado
// alguna vez para ambos portales podria reanudar la sesion equivocada
// (ver el comentario de cabecera de ProveedorApp.jsx). Antes el portal no
// guardaba NADA, por eso F5 siempre deslogeaba.
export const REMEMBER_TOKEN_KEY_PROVEEDOR = 'lastmile_proveedor_remember_token';
